import { STEP_CONFIGS, STEP4_TOP_TITLE_SVG, LAYOUT } from './constants'

interface TitleStepSvgProps {
  stepIndex: number
  isAbsolute?: boolean
  bleedPx?: number
}

export function TitleStepSvg({ stepIndex, isAbsolute = false, bleedPx = 0 }: TitleStepSvgProps) {
  const config = STEP_CONFIGS[stepIndex]
  if (!config) return null
  const isStep23 = stepIndex >= 1 && stepIndex <= 2
  const topOffset = (isStep23 ? 8 : 0) + (isAbsolute ? bleedPx : 0)
  const svg = isAbsolute && stepIndex === 3 ? STEP4_TOP_TITLE_SVG : config.svg

  if (isAbsolute) {
    // Absolute step titles are positioned within the trim area when bleed is present.
    return (
      <div className="absolute" style={{ left: LAYOUT.stepSvgLeft, top: LAYOUT.stepSvgTop + topOffset, zIndex: 1 }}>
        <img src={svg} alt="" width={config.svgWidth} height={config.svgHeight} />
      </div>
    )
  }
  // Step 1: flows in normal content
  return (
    <div style={{ padding: `0 ${LAYOUT.step1SvgPadding}px` }}>
      <img src={svg} alt="" width={config.svgWidth} height={config.svgHeight} />
    </div>
  )
}
